import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { FortuneCatalog } from "../fortune/FortuneCatalog";
import { HomeSection } from "./HomeSection";

export function FortuneSection() {
  return (
    <HomeSection
      id="fortune"
      title="Fortune Games"
      description="Play with Fortune Dollars. Try your luck at Cyber Slots or take a seat at Blackjack."
    >
      <FortuneCatalog limit={6} />
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Button component={Link} to="/fortune" variant="outlined" size="large">
          View all Fortune Games
        </Button>
      </Box>
    </HomeSection>
  );
}
